import { useRef, useState } from 'react'
import { Button, Flex, Text, rem } from '@mantine/core'
import { PipelineParameters } from '../pipeline/Pipeline'
import { UploadCarPerspectiveButton } from '../pipeline/UploadCarPerspectiveButton'
import CanvasDraw from "react-canvas-draw";

export default function FixRims(model: {
  buy: (params: PipelineParameters[]) => Promise<void>;
  loading: boolean
}) {
  const renderRef = useRef<CanvasDraw>(null);


  const [perspective, setPerspective] = useState('')

  return (
    <Flex w={'100%'} mt={12} pt={16} pb={16} pl={20} pr={20} style={{ borderRadius: '4px',background: 'rgba(32, 32, 32, 1)'   }} gap={32}>

      <Flex direction={'column'} miw={'300px'} w={'300px'} gap={12}>
        <Text fz={20}>Fix Rims</Text>
        <UploadCarPerspectiveButton
          onSetImage={(image) => {
            setPerspective(image)
          }} />

        <Flex gap={12} mt={32} justify={'center'}>
          <Button
            styles={{
              root: {
                color: 'rgba(230, 230, 230, 1)',
                height: rem(36),

                fontSize: '14px',
                background: `#f53c02 !important`,
                border: 'none',
                position: 'relative',
              }
            }}
            // disabled={modelParams.prompt.length === 0}
            variant="default"
            onClick={async () => {

              if (renderRef) {

                const pipeline: PipelineParameters = {
                  provider: 'comfy',
                  type: 'fixRims',

                  credits: 0,
                  inputSrc: perspective,

                  srcset: [],
                }
                await model.buy([pipeline]);
                // // const res = await runCreatePipeline(pipeline);

                // if (res.error) {
                //   NOTIFICATION_SERVICE.errorNotification(
                //     "Not enough credits"
                //   );
                //   setBillingModalOpen(true)
                // } else {
                //   spaceStore.addPipeline({
                //     data: res.data,
                //     status: res.status
                //   })
                //   spaceStore.setMode(MODE.PIPELINES)
                // }
              }
            }}
          >
            Generate
          </Button>
        </Flex>
      </Flex>

    </Flex>
  )
}
